export default __webpack_public_path__ + "static/media/PD_END.58d36709.WAV";